export const tenantLogsTypes = {
    GET_TENANT_LOGS_REQUEST: 'GET_TENANT_LOGS_REQUEST',
    GET_TENANT_LOGS_SUCCESS: 'GET_TENANT_LOGS_SUCCESS',
    GET_TENANT_LOGS_FAILURE: 'GET_TENANT_LOGS_FAILURE',
}